<div class="relative" id="dashboard__location-performance-list">
  @if (dashboardStore.stationPerformanceLoading()) {
    <er-table-loader />
  }

  <div class="table-responsive" id="dashboard__location-performance-table">
    <table
      mat-table
      matSort
      (matSortChange)="sortTable($event)"
      [dataSource]="dashboardStore.stationPerformanceEntities()"
      class="mat-elevation-z8"
    >
      <ng-container matColumnDef="internalMerchantStationId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{
            "dashboard.location_performance.table.headers.your_station_id"
              | transloco
          }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.internal_merchant_station_id }}
        </td>
      </ng-container>

      <ng-container matColumnDef="externalStationId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{
            "dashboard.location_performance.table.headers.uta_station_id"
              | transloco
          }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.station_id }}
        </td>
      </ng-container>

      <ng-container matColumnDef="stationName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{
            "dashboard.location_performance.table.headers.station_name"
              | transloco
          }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.station_name }}</td>
      </ng-container>

      <ng-container matColumnDef="stationAddress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{
            "dashboard.location_performance.table.headers.station_address"
              | transloco
          }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.station_address }}
        </td>
      </ng-container>

      <ng-container matColumnDef="dieselVolume">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{
            "dashboard.location_performance.table.headers.diesel_volume"
              | transloco
          }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.diesel_volume | number: "1.2-2" : "de-DE" }} L
        </td>
      </ng-container>

      <ng-container matColumnDef="petrolVolume">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{
            "dashboard.location_performance.table.headers.petrol_volume"
              | transloco
          }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.petrol_volume | number: "1.2-2" : "de-DE" }} L
        </td>
      </ng-container>

      <ng-container matColumnDef="adblueVolume">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{
            "dashboard.location_performance.table.headers.adblue_volume"
              | transloco
          }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.adblue_volume | number: "1.2-2" : "de-DE" }} L
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="dashboardStore.columns()"></tr>
      <tr mat-row *matRowDef="let row; columns: dashboardStore.columns()"></tr>
    </table>
  </div>

  <er-paginator
    [totalRecords]="dashboardStore.stationPerformancePagination.total_records()"
    [pageSize]="dashboardStore.stationPerformancePagination.page_size()"
    [pageIndex]="dashboardStore.stationPerformancePagination.page_index()"
    (changePageSize)="dashboardStore.updateStationPerformancePageSize($event)"
    (changePageIndex)="
      dashboardStore.updateStationPerformancePageIndex($event.pageIndex)
    "
    id="dashboard__table-paginator"
  />
</div>
